module.exports = __webpack_public_path__ + "img/offices.66d42b52.svg";